export class BBPBaseService {
    baseUrl;
    fetchImpl;
    constructor(baseUrl, fetchImpl) {
        this.baseUrl = baseUrl;
        this.fetchImpl = fetchImpl;
    }
    getAuthHeaders() {
        return Promise.resolve({});
    }
    async pair(params) {
        const response = await this.fetchImpl(this.baseUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                ...(await this.getAuthHeaders()),
            },
            mode: "cors",
            body: JSON.stringify(params),
        });
        const result = await response.json();
        if (!response.ok)
            throw new Error(result?.message || `HTTP error! Status: ${response.status}`);
        return result.data;
    }
}
